'use strict';

angular.module('study.import')
.component('importMain', {
    templateUrl: 'modules/import/main.html',
    controller: 'ImportMainController',
});
